import { isAxiosError } from 'axios'

export function formServerError<T>(err: unknown, defaultValues: T): Response {
  const requestId = isAxiosError(err)
    ? (err.response?.headers['x-epages-requestid'] ?? err.response?.headers['x-b3-traceid'] ?? null)
    : null
  const status = isAxiosError(err) ? (err.response?.status ?? 500) : 500
  return Response.json({ serverError: true, requestId, defaultValues }, { status })
}
